import React from 'react';
import {Modal} from 'semantic-ui-react';
import './styles.scss';

const ModalUpdateClient = ({showModal, setShowModal, save}) => {
  const handleSave = (updateClient) => {
    save(updateClient);
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      size={'mini'}
      header={'SE HAN MODIFICADO ALGUNOS CAMPOS DEL CLIENTE ¿DESEA ACTUALIZAR ESA INFORMACIÓN?'}
      className='modal-update-client'
      actions={[
        {
          'key': 'deny',
          'content': 'NO',
          'onClick': () => handleSave(false),
          'primary': false,
        },
        {
          'key': 'affirm',
          'content': 'SI',
          'positive': true,
          'onClick': () => handleSave(true),
          'primary': true,
        },
      ]}
    />
  );
};

export default ModalUpdateClient;
